import mongoose from "mongoose";

export interface IAttachment {
    _id: mongoose.Types.ObjectId;
    type: 'profileImage' | 'certificate' | 'document' | 'identification' | 'chatMedia';
    mimetype: string;
    key: string;
    filename: string;
    fileSize: number;
    uploadedBy: mongoose.Types.ObjectId;
    isTemporary: boolean;
    moduleType: 'profileImage' | 'certificate' | 'document' | 'identification' | 'chatMedia';
    entityId: mongoose.Types.ObjectId;
    entityModel: 'User' | 'Labourer';
    thumbnailKey?: string
    metadata: {
        name?: string;
        issuer?: string;
        issue_date?: Date;
        expiry_date?: Date;
        document_type?: string;
    };
    createdAt: Date;
    url?: string
    deletedAt?: Date
    isDeleted?: boolean
}

export interface IAttachmentResponse {
    _id: mongoose.Types.ObjectId;
    type: 'profileImage' | 'certificate' | 'document' | 'identification' | 'chatMedia';
    mimetype: string;
    key: string;

    filename: string;
    fileSize: number;

    moduleType: 'profileImage' | 'certificate' | 'document' | 'identification' | 'chatMedia';

    url?: string
    thumbnailUrl?: string
}


export enum AttachmentType {
    PROFILE_IMAGE = 'profileImage',
    CERTIFICATE = 'certificate',
    DOCUMENT = 'document',
    IDENTIFICATION = 'identification',
    VIDEO = 'video',
    CHATMEDIA = 'chatMedia'
}
export enum EntityModel {
    USER = 'User',
    LABOURER = 'Labourer',
}

